import { ConditionValueLibraryGroups } from "./condition-value-library-groups"
import { getSpecialistSets } from "./controller/get-specialist-sets"

export function ConditionValueSpecialistSet(props) {
    return (
        <ConditionValueLibraryGroups
            {...props}
            loadOptions={getSpecialistSets}
            placeholder="Select specialist sets..."
        />
    )
}
